import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import { Card } from '../../../layout/Card.jsx';
import { Icon } from '../../../layout/Icon.jsx';
import { Pill } from '../../../layout/Pill.jsx';
import { formatDateTime } from '../../../shared/format.js';

const TYPE_META = {
  purchase: { label: 'شراء', variant: 'info', color: '#0E7490' },
  sale: { label: 'بيع', variant: 'orange', color: '#FF7A1A' },
  adjustment: { label: 'تسوية', variant: 'warning', color: '#92400E' },
  damage: { label: 'تالف', variant: 'danger', color: '#B91C1C' },
  return: { label: 'مرتجع', variant: 'success', color: '#15803D' },
  transfer: { label: 'نقل', variant: 'muted', color: '#6D28D9' }
};

export function MovementsTable({
  movements = [],
  loading,
  page,
  pages,
  total,
  onPageChange
}) {
  const navigate = useNavigate();

  function openRef(refType, refId) {
    if (!refId) return;
    if (refType === 'purchase_invoice') navigate(`/purchase/${refId}`);
  }

  return (
    <Card>
      <div className="overflow-x-auto">
        <table className="w-full text-[13px]">
          <thead className="text-ink-2 text-[12px] sticky top-0 bg-white">
            <tr className="border-b border-line">
              <th className="p-2.5 text-start">التاريخ</th>
              <th className="p-2.5 text-start">المنتج</th>
              <th className="p-2.5 text-start">المخزن</th>
              <th className="p-2.5 text-start">النوع</th>
              <th className="p-2.5 text-start">الكمية</th>
              <th className="p-2.5 text-start">الرصيد بعد</th>
              <th className="p-2.5 text-start">المرجع</th>
              <th className="p-2.5 text-start">المستخدم</th>
              <th className="p-2.5 text-start">ملاحظات</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={9} className="text-center text-ink-3 py-8">جاري التحميل...</td></tr>
            ) : movements.length === 0 ? (
              <tr><td colSpan={9} className="text-center text-ink-3 py-10">لا توجد حركات</td></tr>
            ) : (
              movements.map((m, idx) => {
                const meta = TYPE_META[m.type] || { label: m.type, variant: 'muted' };
                const qty = Number(m.qty || 0);
                return (
                  <tr
                    key={m._id || m.id}
                    className={clsx('border-b border-line hover:bg-paper-2', idx % 2 === 1 && 'bg-paper/40')}
                  >
                    <td className="p-2.5 text-ink-2 whitespace-nowrap">
                      {formatDateTime(m.createdAt)}
                    </td>
                    <td className="p-2.5">
                      <div className="font-bold">{m.productId?.name || '—'}</div>
                      <div className="text-[11px] text-ink-3" style={{ fontFamily: 'monospace' }}>
                        {m.productId?.sku || ''}
                      </div>
                    </td>
                    <td className="p-2.5 text-ink-2">{m.warehouseId?.name || '—'}</td>
                    <td className="p-2.5"><Pill variant={meta.variant}>{meta.label}</Pill></td>
                    <td className="p-2.5">
                      <span className="font-bold" style={{ color: qty > 0 ? '#15803D' : '#B91C1C' }}>
                        {qty > 0 ? '+' : ''}{qty}
                      </span>
                    </td>
                    <td className="p-2.5 font-bold">{m.balanceAfter ?? '—'}</td>
                    <td className="p-2.5">
                      {m.refType && m.refId ? (
                        <button
                          type="button"
                          className="text-orange-deep underline-offset-2 hover:underline text-[12px] flex items-center gap-1"
                          onClick={() => openRef(m.refType, m.refId)}
                        >
                          <Icon name="chevronL" size={12} />
                          {m.refType === 'purchase_invoice' ? 'فاتورة شراء' : m.refType}
                        </button>
                      ) : <span className="text-ink-3">{m.refType || '—'}</span>}
                    </td>
                    <td className="p-2.5 text-ink-2 text-[12px]">{m.userId?.fullName || m.userId?.username || '—'}</td>
                    <td className="p-2.5 text-ink-2 text-[12px] max-w-[200px] truncate">{m.notes || '—'}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
      {pages > 1 ? (
        <div className="card-h border-b-0 border-t flex justify-between items-center text-[12px]">
          <div className="text-ink-3">صفحة {page} من {pages} • {total} حركة</div>
          <div className="flex gap-1">
            <button
              type="button"
              className="btn"
              style={{ padding: '6px 10px' }}
              onClick={() => onPageChange(page - 1)}
              disabled={page <= 1}
            >
              <Icon name="chevronR" size={13} />
            </button>
            <button
              type="button"
              className="btn"
              style={{ padding: '6px 10px' }}
              onClick={() => onPageChange(page + 1)}
              disabled={page >= pages}
            >
              <Icon name="chevronL" size={13} />
            </button>
          </div>
        </div>
      ) : null}
    </Card>
  );
}
